import { render } from "./TrainingElements.vue?vue&type=template&id=20afb090&scoped=true"
import script from "./TrainingElements.vue?vue&type=script&lang=js"
export * from "./TrainingElements.vue?vue&type=script&lang=js"

import "./TrainingElements.vue?vue&type=style&index=0&id=20afb090&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20afb090"]])

export default __exports__